import { getApiUrl } from "../lib/apiUrl.js";

import api from "./api.js";

/** @typedef {{ email: string; password: string }} LoginCredentials */
/** @typedef {{ email: string; password: string; first_name: string; last_name: string }} RegisterData */

/**
 * Normalized user from `/auth/user/` (handles `pk` vs `id`).
 * @param {Record<string, unknown> | null | undefined} raw
 */
function coerceBool(v) {
  if (v === true || v === 1 || v === "1" || v === "true") return true;
  return false;
}

export function normalizeUser(raw) {
  if (!raw || typeof raw !== "object") return null;
  const idRaw = raw.id ?? raw.pk;
  const idNum = idRaw != null ? Number(idRaw) : NaN;
  return {
    id: Number.isFinite(idNum) ? idNum : 0,
    email: String(raw.email ?? ""),
    first_name: String(raw.first_name ?? ""),
    last_name: String(raw.last_name ?? ""),
    is_active: coerceBool(raw.is_active),
    is_staff: coerceBool(raw.is_staff),
    is_superuser: coerceBool(raw.is_superuser),
  };
}

export const authService = {
  /** @param {LoginCredentials} credentials */
  async login(credentials) {
    const { data } = await api.post("/auth/login/", credentials);
    if (data.access) localStorage.setItem("access_token", data.access);
    if (data.refresh) localStorage.setItem("refresh_token", data.refresh);
    return data;
  },

  /** @param {RegisterData} body */
  async register(body) {
    const { data } = await api.post("/auth/registration/", {
      username: body.email,
      email: body.email,
      password1: body.password,
      password2: body.password,
      first_name: body.first_name,
      last_name: body.last_name,
    });
    if (data.access) localStorage.setItem("access_token", data.access);
    if (data.refresh) localStorage.setItem("refresh_token", data.refresh);
    return data;
  },

  async logout() {
    try {
      await api.post("/auth/logout/");
    } catch (e) {
      console.error("Logout error:", e);
    } finally {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
    }
  },

  async getCurrentUser() {
    const { data } = await api.get("/auth/user/");
    return data;
  },

  getGoogleLoginUrl() {
    return `${getApiUrl()}/auth/google/login/`;
  },

  getMicrosoftLoginUrl() {
    return `${getApiUrl()}/auth/microsoft/login/`;
  },
};

export function isAuthenticated() {
  return Boolean(localStorage.getItem("access_token"));
}
